import React from 'react';
import ReactSwitch from 'react-switch';
import { LoiComparisonFormDto } from '../../../../slices/marketplace/loi-comparison/models/loi-comparison-form.model';

export interface SelectedLoiBannerProps {
    item: LoiComparisonFormDto;
    onBuyerClick: () => void;
    canSelectThisBuyer: boolean;
    onSelectClick: () => void;
    onResubmissionToggle: (buyerId: number) => void;
}

export const SelectedLoiBanner = ({
    item,
    onBuyerClick,
    canSelectThisBuyer,
    onSelectClick,
    onResubmissionToggle,
}: SelectedLoiBannerProps) => {
    return (
        <div className={`selected-loi-banner${item.isSelected ? ' selected-loi-banner--selected' : ''}`}>
            <div className="selected-loi-banner-left">
                <span className="clickable-text" onClick={onBuyerClick}>
                    {item.buyerName}
                </span>
                {item.isSelected && (
                    <span className="loi-selected-badge" aria-label="Selected LOI">
                        <span className="loi-selected-badge-check">✓</span>
                        Selected LOI
                    </span>
                )}
            </div>
            <div className="selected-loi-banner-right">
                {item.isResubmissionToggleVisible && (
                    <div className="selected-loi-banner-resubmission">
                        <span className="selected-loi-banner-resubmission-label">Enable Resubmission of Offer</span>
                        <ReactSwitch
                            offColor="#d92550"
                            checked={item.isResubmissionEnabled}
                            onChange={item.canToggleResubmission && !item.isResubmissionEnabled
                                ? () => onResubmissionToggle(item.buyerId)
                                : () => {}}
                            disabled={!item.canToggleResubmission || item.isResubmissionEnabled}
                            height={22}
                        />
                    </div>
                )}
                {item.isSelected ? (
                    <button type="button" className="selected-loi-banner-status-btn" disabled>
                        <span className="selected-loi-banner-status-check">✓</span>
                        Selected LOI
                    </button>
                ) : canSelectThisBuyer && (
                    <button
                        type="button"
                        className="btn btn-primary buyer-summary-card__select-btn"
                        onClick={onSelectClick}
                    >
                        Select &amp; Execute LOI
                    </button>
                )}
            </div>
        </div>
    );
};
